import { ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';
import { ModifiedSessionDocumentInfo } from '../models';

export function payableDocumentsSelection(): ValidatorFn {
  return (
    control: AbstractControl<ModifiedSessionDocumentInfo[]>,
  ): ValidationErrors | null => {
    const documents = control.value?.filter((x) => !x.isCreditMemo);

    if (control.value == null || documents.length === 0) {
      return null;
    }

    const validationError = { payableDocuments: true };
    const payableDocuments = documents.filter((x) => x.isPayable);

    if (payableDocuments.length === 0) {
      return validationError;
    }

    return null;
  };
}
